import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import WhatsappMessageForm from '../../components/Whatsapp/WhatsappMessageForm';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';
const page = `${Page['whatsappMessage']}`;

const WhatsappMessagesNewPage = () => {
  const fetch = useFetch();
  const location = useLocation();
  const whatsappAccount = useSelector((state) => state.whatsapp.account);
  const navigate = useNavigate();

  const [whatsappMessage, setWhatsappMessage] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [guidanceShow, setGuidanceShow] = useState(false);

  const { accountId, domainId } = useParams();

  useEffect(() => {
    const from = queryString.parse(location.search).from;
    if (from) {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/whatsappMessages/${from}`)
        .then(({ whatsappMessage }) => {
          whatsappMessage.name = `copy_of_${whatsappMessage.name}`;
          whatsappMessage.stored = whatsappAccount?.whatsappSender;
          delete whatsappMessage.id;
          setWhatsappMessage(whatsappMessage);
        })
        .catch(setLoadError);
    } else {
      setWhatsappMessage({
        name: 'new_whatsapp_message',
        header: '',
        body: '',
        footer: '',
        type: 'text',
        category: 'MARKETING',
        btnUrl: '',
        btnText: '',
        btnType: 'URL',
        imageUrl: '',
        cardBody: '',
        cards: [],
        numCards: null,
        stored: whatsappAccount?.whatsappSender,
        onDailyLimitReached: 'reschedule',
        maxReschedules: 3,
      });
    }
  }, [accountId, domainId, fetch, location.search, whatsappAccount?.whatsappSender]);

  const create = (whatsappMessage) => {
    setUserError(false);
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/whatsappMessages`, {
      method: 'POST',
      body: JSON.stringify(whatsappMessage),
    })
      .then(({ whatsappMessage }) => {
        setWhatsappMessage(whatsappMessage);
        setGuidanceShow(true);
      })
      .catch(setUserError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!whatsappMessage) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/whatsapp` },
    { title: 'New' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="Whatsapp Message"
        redirect={`/accounts/${accountId}/domains/${domainId}/whatsapp`}
        show={guidanceShow}
        elementTypes={['workflows']}
        element={whatsappMessage}
        setShow={() => setGuidanceShow(false)}
        newElement={true}
      />
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <WhatsappMessageForm
              whatsappMessage={whatsappMessage}
              saveWhatsappMessage={create}
              onBack={() => navigate(-1)}
            />
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default WhatsappMessagesNewPage;
